import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'hd-button',
  styleUrl: './hd-button.pcss',
  shadow: true,
})
export class HdButton {
  @Prop() primary: boolean = false;
  @Prop() outline: boolean = false;
  @Prop() small: boolean = false;
  @Prop() full: boolean = false;
  @Prop() padded: boolean = false;
  /** (optional) Icon to display on the left of the label */
  @Prop() iconLeft: string = '';
  /** (optional) Icon to display on the right of the label */
  @Prop() iconRight: string = '';
  @Prop({ reflect: true }) disabled: boolean = false;
  @Prop() type: 'button' | 'submit' | 'reset';

  render() {
    const classes = {
      'primary': this.primary,
      'outline': this.outline,
      'small': this.small,
      'full': this.full,
      'padded': this.padded,
      'icon-left': !!this.iconLeft.length,
      'icon-right': !!this.iconRight.length
    };

    return (
      <button class={classes} disabled={this.disabled} type={this.type}>
        {!!this.iconLeft.length && <hd-icon svg={this.iconLeft}></hd-icon>}
        <slot></slot>
        {!!this.iconRight.length && <hd-icon svg={this.iconRight}></hd-icon>}
      </button>
    );
  }
}
